import { CheckboxComponent } from './components/basic/checkbox/checkbox.component';
import { DecoratorDirective } from './directives/decorator.directive';

// Import this barrel via a relative path to avoid Angular NG3004.

export const Checkbox = [
  CheckboxComponent,
  DecoratorDirective
];
